import "../Css/Navbar.css";
import logo from "../Images/weddingz adda logo (1).png";
import { NavLink, useLocation } from "react-router-dom";
import DropDown from "../Component/NavBar/DropDown";
// import EnquiryForm from "../Modal/EnquiryForm";
import NavigationLinks from "../Component/NavBar/NavigationLinks";
import { useEffect } from "react";
import { Button, Dropdown, Space } from "antd";
import { FaBriefcase } from "react-icons/fa";
import LeftDrawerNav from "./NavBar/LeftDrawerNav";

function CollapsibleExample() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [pathname]);

  return (
    <header className="header-css">
      <div className="container">
        <NavLink to="/" className="logo">
          <img alt="Weddignz Adda" src={logo} />
        </NavLink>
        <nav className="nav-links d-xl-flex d-none">
          {NavigationLinks.map((val, index) =>
            val.icon ? (
              val?.name === "Know More" ? (
                <Dropdown
                  menu={{
                    items: val?.link.map((valLink, index) => ({
                      key: index + 1,
                      label: (
                        <NavLink
                          style={{ textTransform: "capitalize" }}
                          rel="noopener noreferrer"
                          to={valLink?.link}
                        >
                          {valLink?.name}
                        </NavLink>
                      ),
                    })),
                  }}
                >
                  <NavLink
                    style={{ textTransform: "capitalize" }}
                    to={val?.link[0]?.link}
                  >
                    <Space>
                      {val.name}
                      {val.icon}
                    </Space>
                  </NavLink>
                </Dropdown>
              ) : (
                <DropDown
                  key={index}
                  desc={val.desc}
                  nav={val.name}
                  links={val.link}
                >
                  <NavLink
                    style={{ textTransform: "capitalize" }}
                    className="active"
                    to={Array.isArray(val.link) ? val.link[0].link : val.link}
                  >
                    {val.name}&nbsp;{val.icon}
                  </NavLink>
                </DropDown>
              )
            ) : (
              val.name !== "Home" && (
                <NavLink
                  className="active"
                  key={index}
                  to={Array.isArray(val.link) ? val.link[0].link : val.link}
                >
                  {val.name}&nbsp;{val.icon}
                </NavLink>
              )
            )
          )}
        </nav>
        <LeftDrawerNav />

        <div className="right-layout d-none d-xl-block">
          {/* <ModeControl /> */}
          {/* <EnquiryForm /> */}
          <NavLink to="/are-you-vendor">
            <Button
              style={{
                borderRadius: 0,
                height: 40,
                color: "var(--primaryColor)",
                borderColor: "var(--primaryColor)",
              }}
              icon={<FaBriefcase />}
            >
              Are you vendor ?
            </Button>
          </NavLink>
        </div>
      </div>
    </header>
  );
}

export default CollapsibleExample;
